export default class HelpController {
  constructor() {
    this.name = 'help';
  }
}
